import EventTypes from '../../shared/EventTypes';
import AbstractSideBar from '../AbstractSideBar';
import ElementsTab from '../ElementsTab';
import LayersTab from '../LayersTab';
import PlantsTab from '../PlantsTab';
import InfoTab from './InfoTab';
import ListsTab from './ListTab';
import SearchTab from './SearchTab';

export default class SideBar extends AbstractSideBar {
    options = ['search', 'lists', 'info', 'elements', 'plants', 'layers'];

    init() {
        super.init();
        this.tabs = {
            'search': new SearchTab(this.provider, this.tabContainer),
            'lists': new ListsTab(this.provider, this.tabContainer),
            'info': new InfoTab(this.provider, this.tabContainer),
            'elements': new ElementsTab(this.provider, this.tabContainer),
            'plants': new PlantsTab(this.provider, this.tabContainer),
            'layers': new LayersTab(this.provider, this.tabContainer),
        };

        this.tabContainer.size(this.labelWidth, this.labelHeight * Object.keys(this.tabs).length);
    }

    activate() {
        this.setTab('search');
        if (this.mobile) {
            this.emit(EventTypes.CLOSE_SIDEBAR);
        }
    }
}
